import { render, staticRenderFns } from "./ChangeMembershipComplete.vue?vue&type=template&id=66cbcd63&"
import script from "./ChangeMembershipComplete.vue?vue&type=script&lang=ts&"
export * from "./ChangeMembershipComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports